module.exports = __webpack_public_path__ + "5d5e432322a2db51180a5b27a1545136.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/as.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/as.svg
// module chunks = 0